import {DashboardSolution} from "../data/entities/DashboardSolution";
import {UIState} from "../data/UIState";
import {PageEnums} from "./nav/PageEnums";
import * as React from "react";
import {PrimaryLayout} from "./widgets/PrimaryLayout";
import {SecondaryBar} from "./widgets/SecondaryBar";
import {useState} from "react";
import {solutionDataSource} from "../data/SolutionDataSource";

import './SolutionRegister.pcss';
import {BadgeInfoBlock} from "./solution/BadgeInfoBlock";
import {SolutionOverview} from "./solution/SolutionOverview";
import {RegisteredStatusBox} from "./widgets/RegisteredStatusBox";
import {Alert} from "../data/Alert";
import {action} from "mobx";
import {observer} from "mobx-react";

interface Props {
  dashboardSolution:DashboardSolution|null;
}

export function SolutionRegister(props:Props) {
  if(null==props.dashboardSolution) {
    return <button onClick={()=>{ UIState.currentPage = PageEnums.dashboard; }}>BACK TO DASHBOARD</button>
  } else {
    return <_SolutionRegister dashboardSolution={props.dashboardSolution} />
  }
}


export const _SolutionRegister = observer((props:{dashboardSolution:DashboardSolution}) => {

  const [registrationInProgress, setRegistrationInProgress] = useState(false);
  const [registered, setRegistered] = useState(props.dashboardSolution.registered);

  function register() {
    setRegistrationInProgress(true);
    UIState.registerForSolution(props.dashboardSolution._id)
      .then(()=>{
        props.dashboardSolution.registered = true;
        setRegistered(true);
        setRegistrationInProgress(false);
        UIState.selectDashboardSolution(props.dashboardSolution);
      })
      .catch(action((err)=>{
        try {
            if("REG_USER_MAX"===err.responseJSON.errorCode) {
                props.dashboardSolution.maxRegistrationsReached = true;
                Alert.alert(err.responseJSON.userMessage);
                return;
            }
        } catch(err2) {
          console.log(err2);
        }
        Alert.alert("Failed to register. Please make sure your internet connection is stable and try again.")
        setRegistrationInProgress(false);
      }));
  }

  const secondaryBarSubTitle = ('challenge'===props.dashboardSolution.type || 'health fair'===props.dashboardSolution.type) ? props.dashboardSolution.beginsOn : props.dashboardSolution.subTitle;

  return (
    <PrimaryLayout className={'solution-register'}>
      <SecondaryBar
        title={props.dashboardSolution.name}
        subTitle={secondaryBarSubTitle}
        buttonAction={()=>{ UIState.currentPage = PageEnums.dashboard; }}
        buttonLabel={`Back to Dashboard`}
      >
        {registered ?
          <RegisteredStatusBox />
          :
            (props.dashboardSolution.maxRegistrationsReached ?
                    <button style={{backgroundColor:'rgba(0,0,0,.15)', color:'black'}} disabled={true}>Registration Full</button>
                    :
                    <button onClick={register} disabled={registrationInProgress}>Register Now!</button>
            )
        }
      </SecondaryBar>
      <main>
        <div className={"full-width-preview"}>
          <img src={props.dashboardSolution.photoObject.photo} />
        </div>
        <div className={"pl-inner"}>
          <SolutionOverview dashboardSolution={props.dashboardSolution} />
          <div className={"sr-bottom"}>
          {registered ?
            <div className={"registered"}>
              <span className="material-icons">check_circle</span>
              <span className={"text"}>Registered</span>
            </div>
            :
              ( !props.dashboardSolution.maxRegistrationsReached  && <a href="#" onClick={register}>Register to participate</a> )
          }
          </div>
        </div>
      </main>
    </PrimaryLayout>
  );


});
